module.exports = __webpack_public_path__ + "static/img/aff5.bdae678b.png";